import {createSlice} from "@reduxjs/toolkit";

const initialProductsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  productList: null,
  product: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const productsSlice = createSlice({
  name: "products",
  initialState: initialProductsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getProductList
    productsFetched: (state, action) => {
      const {totalCnt, goodsList} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.productList = goodsList;
      state.totalCount = totalCnt;
    },
    // getProductById
    productFetched: (state, action) => {
      const {product} = action.payload;
      state.actionsLoading = false;
      state.product = product;
      state.error = null;
    },
  }
});
